import APIService from './APIService'

const api = APIService()

const base = scope => {
  if (scope.type === 'portfolio') return `/portfolios/${scope.id}/safety-roles`
  if (scope.type === 'estate') return `/estates/${scope.id}/safety-roles`
  return `/building-passport/${scope.id}/assigned-users/safety-roles`
}

export const applySafetyRole = (scope, body) =>
  api.post(`${base(scope)}/${scope.type === 'bp' ? 'apply' : 'bulk'}`, body)

export const getSafetyRoleCandidates = scope =>
  api.get(`${base(scope)}/candidates`)
